import React from 'react';
import menuIcons from '../../assets/images/menuIcons.svg';

const DokanMenuIcons = ({ icon, size = 4, isSubMenu = false }) => (
    <span
        className={` ${
            isSubMenu
                ? 'p-10px bg-pillColor-productType rounded-3xl border border-primary bg-white'
                : ''
        }`}
    >
        <svg className={`icon h-${size} w-${size} `}>
            <use xlinkHref={`${menuIcons}${icon}`} />
        </svg>
    </span>
);

export default DokanMenuIcons;
